@if (this.insuranceClaimModel$ | async; as insuranceClaimModel) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="insuranceClaimStatusHistories"
    role="tabpanel"
    aria-labelledby="insuranceClaimStatusHistories-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="insuranceClaimModel.insuranceClaimStatusHistories"
            [tabViewName]="'statusHistories'"
            (onActionClickedSetRowData)="onSetRowData($event)"
          />
        </div>
      </div>
    </div>
  </div>
}
